import * as util from 'util';
import _ from 'lodash';
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {GeneralService} from "../../../../services/generalService";
import {DICTIONARY} from "../../../../dictionary";
import {Component, OnInit} from "@angular/core";

@Component({
  selector: 'app-archive-reviewers',
  templateUrl: './archive-reviewers.component.html'
})
export class ArchiveReviewersComponent implements OnInit {
	constructor(private rs:RouteService,
				private ns:NotificationService,
				public gs:GeneralService){
	}

	dic = DICTIONARY;

	reviewers;
	userInfo;
	isLoaded = false;
	selectedUsers: any[];
	reviewerPermissionPopup;
	usersSelectionPopup: any;
	addReviewerInProcess;

	ngOnInit() {
		this.gs.getUserInfo(false, (userInfo) => {
			this.userInfo = userInfo;
		});

		this.rs.getArchiveConfiguration().then(response => {
			this.reviewers = response.archive.reviewers;
			this.isLoaded = true;
		}, (err) => {
			this.isLoaded = true;
		});
	};

	showReviewerActions = (reviewerObj) => {
		let actions = [
			this.dic.CONSTANTS.reviewerActions.modifyPermissions,
			this.dic.CONSTANTS.inboundConfigurationsActions.remove
		];

		return actions;
	}

	showReviewerBulkActions = () => {
		return [
			this.dic.CONSTANTS.inboundConfigurationsActions.remove
		];
	}

	selectReviewerAction = (reviewerObj, action) => {
		reviewerObj.showActions = false;
		switch (action) {
			case this.dic.CONSTANTS.inboundConfigurationsActions.remove:
				this.removeReviewers([reviewerObj]);
				break;

			case this.dic.CONSTANTS.reviewerActions.modifyPermissions:
				this.openReviewerPermissionPopup(reviewerObj);
				break;
		}
	};

	reviewerPermissionExecute = (reviewerObj, type) => {
		const actionInfo = {
			type,
			enabled: reviewerObj[type]
		};
		this.rs.updateArchiveReviewer(reviewerObj.email, actionInfo).then(res => {
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
		});
	}

	selectMultipleReviewerAction = (selectedItems, action) => {
		switch (action) {
			case this.dic.CONSTANTS.inboundConfigurationsActions.remove:
				this.removeReviewers(selectedItems);
				break;
		}
	};

	openUsersSelection = () => {
		this.selectedUsers = _.map(this.reviewers, 'email');
		this.usersSelectionPopup = {
			show: true
		};
	}

	addExistUsersToReviewers(users) {
		// Step 1: Filter out existing reviewers
		const existingEmails = _.map(this.reviewers, 'email');
		const filteredUsers = users.filter(user => !existingEmails.includes(user));

		// Step 2: Map filtered users to new reviewers structure
		const newReviewers = filteredUsers.map(user => ({
			email: user,
			isEditMode: false,
			isNew: true,
			edit: {
				email: user,
				allow_view_content: true,
				allow_trends_page: true,
			}
		}));

		if (newReviewers.length) {
			const options = {flags: {allow_view_content: true, allow_trends_page: true}};
			newReviewers.forEach(user => {
				this.rs.addArchiveReviewer(user.email, options).then(res => {
					this.reviewers.push({email: user.email, allow_view_content: true, allow_trends_page: true});
					this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, user.email));
				});
			});
		}
	};

	startRemoveFromUsersSelection = (users) => {
		const reviewersToRemove = this.reviewers.filter(reviewer => users.includes(reviewer.email));

		if (reviewersToRemove.length > 0) {
			this.removeReviewers(reviewersToRemove);
		}
	}

	removeReviewers = (reviewers) => {
		if (!reviewers || !reviewers.length) {
			return;
		}

		let title, subTitle, body;
		if (reviewers.length === 1) {
			body = ['User will not have permission to review case anymore.'];
			title = 'Remove reviewing permission';
			subTitle = `Remove ${reviewers[0].email} permission as a reviewer from Archive cases`;
		}
		else {
			body = [`Review permission of ${reviewers.length} users will be removed from Archive cases.`];
			title = `Remove reviewing permission`;
			subTitle = `Remove reviewing permission - ${reviewers.length} users`;
		}

		this.gs.showPopup({
			title: title,
			subTitle: subTitle,
			body: body,
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Remove',
			doneCb: () => {
				_.map(reviewers, reviewer => {
					const _reviewerObj = _.find<any>(this.reviewers, itm => itm.email === reviewer.email);
					if (_reviewerObj) {
						this.rs.deleteArchiveReviewer(reviewer.email).then(res => {
							_.remove<any>(this.reviewers, _reviewerObj);

							this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemDeleted, 'Reviewer', reviewer.email));
						});
					}
				});
			}
		});
	};

	openReviewerPermissionPopup = (reviewerObj) => {
		this.reviewerPermissionPopup = {
			show: true,
			reviewerObj: reviewerObj
		};
	};

	startAddReviewer() {
		if (this.addReviewerInProcess) {
			return;
		}

		this.addReviewerInProcess = true;

		const newReviewer = {
			isEditMode: true,
			isNew: true,
			edit: {
				email: '',
				allow_view_content: true,
				allow_trends_page: true
			}
		};

		this.reviewers.unshift(newReviewer);
	};

	confirmAddReviewer = (reviewer ,isApproved) => {
		// new reviewer process was declined
		if (!isApproved) {
			_.remove<any>(this.reviewers, reviewer);
			this.addReviewerInProcess = false;
			return;
		}
		//

		// new reviewer approved
		if (!reviewer.edit.email) {
			return this.ns.showErrorMessage(util.format(this.dic.ERRORS.accountEmailMissingName, 'Reviewer email field'));
		}
		if (!this.gs.validateEmail(reviewer.edit.email)) {
			return this.ns.showErrorMessage(util.format(this.dic.ERRORS.invalidEmail, reviewer.edit.email));
		}
		if (_.find(this.reviewers, rev => {return !rev.isNew && rev.email && rev.email === reviewer.edit.email})) {
			return this.ns.showErrorMessage(util.format(this.dic.ERRORS.emailAlreadyExist, reviewer.edit.email));
		}
		reviewer.confirmEditInProcess = true;
		const emailFormatted = reviewer.edit.email.toLowerCase()
		const options = {flags: {allow_view_content: true, allow_trends_page: true}};
		this.rs.addArchiveReviewer(emailFormatted, options).then(res => {
			this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Reviewer'));

			reviewer.email = emailFormatted;
			reviewer.allow_view_content = true;
			reviewer.allow_trends_page = true;
			reviewer.edit = null;
			reviewer.confirmEditInProcess = false;
			reviewer.isEditMode = false;
			reviewer.isNew = undefined; // keep it 'undefined' and not 'false' for sticking the item to the top of the table only when in edit

			this.addReviewerInProcess = false;
		}, (err) => {
			reviewer.confirmEditInProcess = false;
			this.addReviewerInProcess = false;
		});
	};

	searchReviewer = (searchTerm, activeFilters) => {
		this.reviewers.forEach(record => {
			// search
			if (searchTerm) {
				const isFound = searchTextExecute(record, searchTerm);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	};
}

function searchTextExecute(reviewer, searchTerm) {
	return (reviewer.email?.toLowerCase().indexOf(searchTerm) > -1);
}
